<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="closePanel()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="divForm" id="arriba">
    <form [formGroup]="editForm">
      <div *ngIf="isUpdateMode || isDuplicateMode" class="panel-context-title">
        <div class="panel-context-title__tipo">
          {{ loadedTipoNombre || (translation?.Tipo || "Tipo") }}
        </div>
        <div *ngIf="loadedProductoNombre" class="panel-context-title__producto">
          <span class="panel-context-title__producto-label">
            {{ translation?.NombreProducto || "Nombre producto" }}:
          </span>
          <span class="panel-context-title__producto-value">{{ loadedProductoNombre }}</span>
        </div>
      </div>
      <div
        class="top-fields-hint top-fields-hint--top"
        *ngIf="!hasTipoSeleccionado && !isUpdateMode"
        [innerHTML]="hintSeleccioneTipoParaProductoHtml"
      ></div>
      <div class="top-fields" *ngIf="!isUpdateMode">
        <div class="top-field top-field--tipo">
          <app-input-filter
            formControlText="TipoProducto"
            [label]="translation?.Tipo || 'Tipo'"
            [placeHolderTranslation]="translation?.Tipo || 'Tipo'"
            [list]="tiposProducto"
            textShow="name"
            dataInput="value"
            [data]="editForm.get('TipoProducto')?.value"
            [uiSyncKey]="inputFilterUiSyncKey"
            [required]="true"
            [autoValidate]="true"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromClose($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
        </div>

        <div
          class="top-field top-field--producto"
          [class.top-field--producto-invalid]="showProductoNombreRequeridoDebajo()"
        >
          <app-input-filter
            formControlText="ProductoId"
            [label]="translation?.NombreProducto || 'Nombre producto'"
            [placeHolderTranslation]="productoPlaceholder"
            [list]="productosOptions"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editForm.get('ProductoId')?.value"
            [uiSyncKey]="inputFilterUiSyncKey"
            [required]="true"
            [autoValidate]="true"
            [validateTrigger]="submitValidationTick"
            [disabled]="productoDisabled"
            [parentSubmitRequiredLatch]="productoSubmitRequiredLatch"
            [suppressParentSubmitLatch]="!hasTipoSeleccionado"
            (close)="syncInputFilterFromClose($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>
          <div
            class="producto-nombre-requerido-msg"
            *ngIf="showProductoNombreRequeridoDebajo()"
          >
            * {{ translation?.CampoRequerido || "Campo requerido" }}
          </div>
        </div>
      </div>
      <div class="taxonomia-block">
        <div class="taxonomia-title">{{ translation?.Taxonomia || "Taxonomía" }}</div>

        <div class="taxonomia-grid">
          <app-input-filter
            formControlText="TXCentroCosteId"
            [label]="labelTxCentroCoste"
            [placeHolderTranslation]="labelTxCentroCoste"
            [list]="txCentroCosteOptions"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editForm.get('TXCentroCosteId')?.value"
            [uiSyncKey]="inputFilterUiSyncKey"
            [required]="true"
            [autoValidate]="true"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromClose($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>

          <app-input-filter
            formControlText="TXTipoPrecioId"
            [label]="labelTxTipoPrecio"
            [placeHolderTranslation]="labelTxTipoPrecio"
            [list]="txTipoPrecioOptions"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editForm.get('TXTipoPrecioId')?.value"
            [uiSyncKey]="inputFilterUiSyncKey"
            [required]="true"
            [autoValidate]="true"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromClose($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>

          <app-input-filter
            formControlText="TXCanalVentasId"
            [label]="labelTxCanalVentas"
            [placeHolderTranslation]="labelTxCanalVentas"
            [list]="txCanalVentasOptions"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editForm.get('TXCanalVentasId')?.value"
            [uiSyncKey]="inputFilterUiSyncKey"
            [required]="true"
            [autoValidate]="true"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromClose($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>

          <app-input-filter
            *ngIf="showAlojamiento"
            formControlText="TXAlojamientoId"
            [label]="labelTxAlojamiento"
            [placeHolderTranslation]="labelTxAlojamiento"
            [list]="txAlojamientoOptions"
            textShow="Nombre"
            dataInput="pkId"
            [data]="editForm.get('TXAlojamientoId')?.value"
            [uiSyncKey]="inputFilterUiSyncKey"
            [required]="false"
            [autoValidate]="false"
            [validateTrigger]="submitValidationTick"
            (close)="syncInputFilterFromClose($event)"
            (selected)="syncInputFilterFromChild($event)"
          ></app-input-filter>

          <ng-container *ngFor="let level of [1,2,3,4,5,6,7]">
            <mat-form-field appearance="outline" *ngIf="txNiveles[level]?.length">
              <mat-label>{{ nivelTxMatLabel(level) }}</mat-label>
              <mat-select
                [formControlName]="'Nivel' + level"
                [compareWith]="compareByNivelNombre"
                (selectionChange)="onNivelTaxonomiaChange(level)"
              >
                <mat-option *ngFor="let item of txNiveles[level]" [value]="item">
                  {{ displayTaxonomiaNivelNombre(item) }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="validateFields('Nivel' + level)">
                {{ getRequiredError() }}
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>

        <div class="taxonomia-info">
          <div class="info-item" *ngIf="hasRevenueCategoryValue">
            <span class="info-label">{{ infoLabelRevenueCategory }}:</span>
            <span class="info-value">{{ revenueCategoryInfo }}</span>
          </div>
          <div
            class="info-item info-item--cuenta-visitante"
            *ngIf="hasCuentaVisitanteValue"
          >
            <span class="info-label">{{ infoLabelCuentaVisitante }}:</span>
            <span class="info-value">{{ cuentaVisitanteInfo }}</span>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
